import {ACTION_CODE} from './_actionCode';
import {PennylaneService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_UNMATCHED_TRANSACTIONS';

export async function getUnmatchedTransactions(userData: Record<string, string>) {
    try {
        LoggerService.logInfo('Action - getUnmatchedTransactions - Start');

        const getUnmatchedTransactionsResult = await PennylaneService.getUnmatchedTransactions(userData);

        LoggerService.logInfo('Action - getUnmatchedTransactions - End - Success');

        return ResultModel.newSuccessResult(getUnmatchedTransactionsResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getUnmatchedTransactions - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
